import { Service } from '@/services/api';

export interface WizardStatePayload {
  currentStep: number;
  metaData: Record<string, unknown>;
}

export interface WizardState {
  accountId: number;
  currentStep: number;
  metaData: Record<string, unknown>;
  createdAt: string | null;
  updatedAt: string | null;
  updatedBy: string | null;
}

class DataReadinessWizardService extends Service {
  async getState(accountId: number): Promise<WizardState> {
    return this.get<WizardState>(`/v1/account/${accountId}/data-readiness-wizard`).then(this.handleResponse);
  }

  async putState(accountId: number, payload: WizardStatePayload): Promise<WizardState> {
    return this.put<WizardState>(`/v1/account/${accountId}/data-readiness-wizard`, payload).then(this.handleResponse);
  }
}

export default new DataReadinessWizardService();
